import AdvancedController from "./advanced-controller"

export default class HeaderController extends AdvancedController {

    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
        windowWidth: Number,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton"
    ]

    connect() {
        super.connect();
        this.navMainTarget = document.getElementById('nav-main');
        this.navServicesTarget = document.getElementById('nav-services');

        this.navServicesTargetUl = this.navServicesTarget.querySelector('ul');
        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        });
        this.resize();
    }

    resize() {
        this.windowWidth = window.innerWidth

        if (this.windowWidth < 768) {
            this.navServicesTargetUl.classList.add('-moved-menu');
            this.navMainTarget.append(this.navServicesTargetUl);
        } else {
            if (this.navServicesTargetUl.classList.contains('-moved-menu')) {

                this.navServicesTarget.append(this.navMainTarget.querySelector('.-moved-menu'));
                this.navServicesTarget.children[0].classList.remove('-moved-menu');
            }
        }
    }

    onToggleClick(e) {
        e.preventDefault();

        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();


        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
            this.navServicesTarget.style.display = "flex"

        } else {
            this.navMainTarget.style.display = "none"
            this.navServicesTarget.style.display = "none"
        }
        if (this.hasSearchFormTarget) {
            if (this.isSearchToggledValue) {
                this.searchFormTarget.style.display = "flex"
                this.searchFieldTarget.focus()
            } else {
                this.searchFormTarget.style.display = "none"
            }
        }
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }

}